class Customer {
	constructor({
		id = '',
		name = '',
		email = '',
		confirmEmailNewsYn = 1,
		profileColor = '',
		verifiedYn = 0,
		createdAt = '',
		accessToken = '',
		refreshToken = '',
	} = {}) {
		this.id = id === null ? '' : id
		this.name = name === null ? '' : name
		this.email = email === null ? '' : email
		this.confirmEmailNewsYn = confirmEmailNewsYn === null ? 1 : confirmEmailNewsYn
		this.profileColor = profileColor === null ? '' : profileColor
		this.verifiedYn = verifiedYn === null ? 0 : verifiedYn
		this.createdAt = createdAt === null ? '' : createdAt
		this.accessToken = accessToken === null ? '' : accessToken
		this.refreshToken = refreshToken === null ? '' : refreshToken
		this.confirmEmailNewsYn = confirmEmailNewsYn === null ? 0 : confirmEmailNewsYn
	}
	id: string
	name: string
	email: string
	confirmEmailNewsYn: number
	profileColor: string
	verifiedYn: number
	createdAt: string
	accessToken: string
	refreshToken: string
}

export { Customer }
